module.exports = __webpack_public_path__ + "media/images/top/top_consultant_img_03-a0ea40a6cb3da3993b8f59f883945b5b.png";